export interface RedirectObj {
  _type?: 'redirectObj'
  isExternal?: boolean
  originPath?: string
  redirectPath?: string
}

export interface RedirectGroup {
  _type?: 'redirectGroup'
  redirects?: RedirectArrayItem[]
}

export type RedirectArrayItem = RedirectObj | RedirectGroup | null | undefined

export const flattenRedirectArray = (
  redirectArray?: RedirectArrayItem[]
): RedirectObj[] => {
  if (!Array.isArray(redirectArray)) {
    return []
  }

  return redirectArray.reduce<RedirectObj[]>((redirects, item) => {
    if (!item) {
      return redirects
    }

    if ('redirects' in item && Array.isArray(item.redirects)) {
      redirects.push(...flattenRedirectArray(item.redirects))
      return redirects
    }

    if ('originPath' in item && item.originPath && item.redirectPath) {
      redirects.push(item)
    }

    return redirects
  }, [])
}
